<template>
  <v-container grid-list-md>
    <PdfModal v-if="pdfData" :pdf-data="pdfData" @downLoadPDF="downLoadPDF" />
    <page-title text="VOA Order Summary" />
    <BaseReportLink
      :actionLinks="GENERATELINKS"
      @onCommandEvent="onCommandEvent"
    />
    <section>
      <v-layout row wrap class="my-3">
        <v-flex xs12>
          <BaseCard :links="reportData" />
        </v-flex>
      </v-layout>
      <v-layout row wrap class="my-5">
        <v-flex xs12>
          <BaseTable
            :items="TABLE"
            :fields="headers"
            hide-default-footer
            label="Borrower Details"
            labelclass="text-button"
            @sendMail="sendMails"
          >
          </BaseTable>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="my-5">
        <v-flex xs12 md12>
          <BaseTable
            :items="orderStatusItems"
            :fields="orderStatusFields"
            hide-default-footer
            label="Order History"
            labelclass="text-button"
          >
          </BaseTable>
        </v-flex>
      </v-layout>

      <v-layout row wrap class="my-5">
        <v-flex xs12 md12>
          <div v-if="generatedReportItems.length > 0" class="my-3">
            <BaseTable
              :items="generatedReportItems"
              :fields="generatedReportFeilds"
              :rows="generatedReportItems.length"
              src-page="accountchekSummary"
              hide-default-footer
              label="Report History"
              class="text-button"
              @generatePDF="onClickShowPDFModal"
            >
            </BaseTable>
          </div>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 md12 class="my-5">
          <BaseLabel label="Status History" vclass="text-button" />
          <ul class="events p-0" align="center">
            <li v-for="itemStatus in infoModel" :key="itemStatus.statusDate">
              <time>{{ itemStatus.statusDate }}</time>
              <div class="circle"></div>
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    <u
                      :id="itemStatus.statusDate"
                      @mouseover="itemStatus.hovered = true"
                      @mouseleave="itemStatus.hovered = false"
                      :class="{
                        'primary--text font-weight-bold': itemStatus.hovered
                      }"
                    >
                      {{ itemStatus.statusInfo }}
                    </u>
                  </span>
                </template>
                <div>{{ itemStatus.statusInfoDetail }}</div>
              </v-tooltip>
            </li>
          </ul>
        </v-flex>
      </v-layout>
    </section>
  </v-container>
</template>

<script>
import BaseCard from '../../sections/BaseCard.vue'
import BaseTable from '../../sections/BaseTable.vue'
import common from '../../../utils/common'
import constant from '../../../constants/constant'
import { mapActions } from 'vuex'
import * as apiTypes from '@/services/api/api-types'
import { mapGetters } from 'vuex'
import PdfModal from '../../sections/pdfModal.vue'

const EventCodes = {
  generate: 1,
  view_transferReport: 2,
  view_Refresh: 4
}
export default {
  components: {
    BaseCard,
    BaseTable,
    PdfModal
  },
  data() {
    return {
      reportData: [],
      isInterfaceCustomer: false,
      responseData: [],
      status: '',
      orderFileId: '',
      displayPdfView: false,
      displayGenerate: false,
      displayRefreshIcon: false,
      displayResendEmail: false,
      pdfData: null,
      isRefreshPeriod: 'No',
      isPdfGenerated: 'No',
      referenceNumber: '',
      statusMessage: '',
      headers: [
        { text: 'NAME', value: 'name', sortable: false },
        { text: 'EMAIL', value: 'email' },
        { text: 'URL', value: 'url' },
        { text: 'Actions', value: 'actions' }
      ],
      orderStatusItems: [],
      orderStatusFields: [
        { text: 'DATE ORDERED', value: 'date' },
        { text: 'VERIFICATION TYPE', value: 'verification' },
        { text: 'ACCOUNT HISTORY', value: 'account' },
        { text: 'REFRESH PERIOD', value: 'refresh' }
      ],
      infoModel: [],
      generatedReportItems: [],
      generatedReportFeilds: [
        {
          text: 'Report Date',
          value: 'reportDate',
          sortable: false,
          width: '70%',
          align: 'start'
        },
        {
          text: 'Report',
          value: 'fileName',
          sortable: false,
          width: '30%',
          align: 'start'
        }
      ],
      refreshPeriodValue: 0
    }
  },
  computed: {
    ...mapGetters(['config']),
    TABLE() {
      return [
        {
          name: this.responseData.borrowerName,
          email: this.responseData.borrowerEmail,
          url: this.responseData.url,
          isDisplayMail: !this.displayResendEmail,
          isShowDelete: false,
          label: 'Delete Borrower'
        }
      ]
    },
    ORDERID() {
      return this.config.orderId || this.$route.params.orderId || 0
    },
    TOKEN() {
      return this.$route.query.Token || ''
    },
    GENERATELINKS() {
      return [
        {
          text: 'Generate Report',
          event: EventCodes.generate,
          isShow: this.displayGenerate
        },
        {
          text: 'View Report',
          event: EventCodes.view_transferReport,
          icon: '',
          isShow: this.displayPdfView || this.displayRefreshIcon,
          type: 'button'
        },
        {
          text: 'Refresh',
          event: EventCodes.view_Refresh,
          icon: '',
          isShow: this.displayRefreshIcon
        }
      ]
    }
  },
  methods: {
    ...mapActions([
      'addTask',
      'removeTask',
      'setNotification',
      'doGET',
      'setPDFView',
      'doPOST'
    ]),
    onClickShowPDFModal(data) {
      const receivedReport = this.generatedReportItems?.find(
        (array) => array.fileName === data
      )?.fileData
      this.pdfData = common.prepareObjectForPDFModalView(receivedReport, data)
      this.setPDFView(true)
    },
    updateReportHistory(data) {
      this.generatedReportItems = []
      if (data.voaPdfFiles.length > 0) {
        this.generatedReportItems = data.voaPdfFiles || []
        this.generatedReportItems.map((file, i) => {
          file.originalReport = this.generatedReportItems.length === i + 1
        })
        // this.reportLinkDisabled = false
      }
    },
    getRefreshPeriodLabels(key) {
      switch (key) {
        case 1:
          return 'One Time Report'
        case 30:
          return '30 Days'
        case 60:
          return '60 Days'
        case 90:
          return '90 Days'
      }
      return ''
    },
    downLoadPDF(data) {
      return common.downloadFile(
        data,
        'application/pdf',
        this.pdfData.fileName || 'VOA_Report',
        true
      )
    },
    onCommandEvent(command) {
      switch (command) {
        case EventCodes.generate:
          this.generateReport()
          break
        case EventCodes.view_transferReport:
          this.downloadOrderFile()
          break
        case EventCodes.view_Refresh:
          this.refreshVoaResult()
          break
      }
    },
    refreshVoaResult() {
      this.doGET({
        getType: apiTypes.CPSS_GET_VOA_REPORT,
        params: {
          token: this.TOKEN,
          orderId: this.ORDERID
        }
      }).then((data) => {
        this.orderFileId = data.orderFieldId
        this.updateReportHistory(data)
      })
    },

    downloadOrderFile() {
      // eslint-disable-next-line no-alert
      this.doGET({
        getType: apiTypes.CPSS_GET_DOCUMENT_DOWNLOAD,
        params: {
          token: this.TOKEN,
          orderId: this.orderFileId
        }
      }).then((data) => {
        this.pdfData = common.prepareObjectForPDFModalView(
          data.fileData,
          data.fileName
        )
        this.setPDFView(true)
      })
    },

    generateReport() {
      this.doGET({
        getType: apiTypes.CPSS_GET_VOA_REPORT,
        params: {
          token: this.TOKEN,
          orderId: this.ORDERID
        },
        errorMessage: 'An error occured while Generating Report'
      }).then((data) => {
        this.status = data.status
        this.isRefreshPeriod = data.isRefreshPeriod
        this.isPdfGenerated = data.isPdfGenerated
        this.orderFileId = data.orderFieldId
        this.getStatus()
        const respData = data
        const url = common.downloadFile(
          respData.reportByteArray,
          constant.contentType.pdf,
          `VoA_${respData.orderId}`
        )
        // window.open(routeData.href, '_blank')
        this.setPDFView(true)
        this.pdfData = respData
      })
    },
    // eslint-disable-next-line complexity
    getStatus() {
      if (this.status !== '507' && this.status !== '513') {
        this.NotAcceptedTerms()
      } else if (this.status === '513') {
        this.RefreshPeriodEnded()
      } else if (this.status === '507' && this.isPdfGenerated === 'No') {
        this.ReportCreated()
      } else if (
        this.status === '507' &&
        this.isPdfGenerated === 'Yes' &&
        this.isRefreshPeriod === 'No'
      ) {
        this.ReportCreatedWithoutRefresh()
      } else if (
        this.status === '507' &&
        this.isPdfGenerated === 'Yes' &&
        this.isRefreshPeriod === 'Yes'
      ) {
        this.ReportCreatedWithRefresh()
      }

      // fix for the refresh period completed scenario
      if (this.refreshPeriodValue && Number(this.refreshPeriodValue) <= 0) {
        this.ReportCreatedWithoutRefresh()
      }
    },
    NotAcceptedTerms() {
      this.displayResendEmail = true
      this.statusMessage = 'In Progress'
    },
    RefreshPeriodEnded() {
      this.displayPdfView = true
      this.displayGenerate = false
      this.displayRefreshIcon = false
      this.displayResendEmail = false
      this.statusMessage = 'Completed'
    },

    ReportCreated() {
      this.displayGenerate = true
      this.displayResendEmail = true
      this.displayPdfView = false
      this.displayRefreshIcon = false
      this.statusMessage = 'In Progress'
    },
    ReportCreatedWithoutRefresh() {
      this.displayPdfView = true
      this.displayGenerate = false
      this.displayRefreshIcon = false
      this.displayResendEmail = false
      this.statusMessage = 'Completed'
    },
    ReportCreatedWithRefresh() {
      this.displayPdfView = true
      this.displayRefreshIcon = true
      this.displayResendEmail = true
      this.displayGenerate = false
      this.statusMessage = 'In Progress'
    },
    sendMails() {
      const payload = { orderId: this.ORDERID }
      this.doPOST({
        product: apiTypes.CPSS_POST_SEND_MAIL,
        payload,
        token: this.TOKEN,
        errorMessage: 'An error occured while Sending Email',
        successMsg: 'Email Sent Successfully',
        errorParams: {
          router: this.$router,
          redirect500: true
        }
      })
    }
  },
  mounted() {
    this.doGET({
      getType: apiTypes.CPSS_GET_VOA_ACCOUNTCHEK_SUMMARY,
      params: {
        token: this.TOKEN,
        orderId: this.ORDERID
      },
      errorMessage: 'An error occured while loading the VOA summary data',
      errorParams: {
        router: this.$router,
        redirect500: true
      }
    }).then((data) => {
      this.status = data.status
      this.referenceNumber = data.referenceNumber
      this.isPdfGenerated = data.isPdfGenerated
      this.isRefreshPeriod = data.isRefreshPeriod
      this.orderFileId = data.orderFieldId
      this.isInterfaceCustomer = data.isInterfaceCustomer
      this.refreshPeriodValue =
        data.refreshPeriod === 1 ? null : data.remainingDays || null
      this.getStatus()
      this.responseData = data
      this.orderStatusItems = [
        {
          date: data.responseTime,
          verification: data.verificationType,
          account: `${data.accountHistory} days`,
          refresh: this.getRefreshPeriodLabels(data.refreshPeriod),
          remaining: data.remainingDays
        }
      ]
      data.orderStatus.map((item) => {
        this.infoModel.push({ ...item, ...{ hovered: false } })
      })
      this.reportData.push(
        [{ text: 'Status', value: this.statusMessage }],
        [
          {
            text: 'Reference Number',
            value: this.referenceNumber
          }
        ]
      )
      if (this.isInterfaceCustomer) {
        this.reportData[0].splice(1, 0, {
          text: 'Report ID',
          value: data.avantusOrderId
        })
      }
      this.updateReportHistory(data)
    })
  }
}
</script>

<style scoped>
.circle {
  z-index: 2;
  width: 0.98em;
  height: 0.8em;
  content: '';
  background-color: #3949ab;
  border: 1px rgb(204, 204, 204) solid;
  border-radius: 50%;
  transform: translateX(50%);
}
.events li {
  display: flex;
}
.events time {
  position: relative;
  width: 21%;
  padding: 0 2.5em 1.5em 0;
  font-size: 12px;
  color: #2f2f2f;
  text-align: right;
}
.events span {
  position: relative;
  padding: 0 0 0.5em 1.5em;
  font-size: 12px;
}
.events span u {
  cursor: pointer;
}
.events span::before {
  position: absolute;
  left: -1px;
  z-index: 1;
  height: 100%;
  content: '';
  border-left: 2px solid #ccc;
}
.events li:last-child span::before {
  border-left: none;
}
.events {
  margin: 1em;
}
.events:last-child {
  border-left: none;
}

.events *::before,
.events *::after {
  box-sizing: border-box;
}
.v-tooltip__content {
  max-width: 40%;
}
</style>
